const deletePlacesStr = {
  toastr: 'Lugar eliminado',
  toastr1: 'eliminado con éxito'
};

export default deletePlacesStr;
